import React from "react";
import { Link } from "gatsby";
import "./menu.scss";
const menu = (props) => (
    <>
    <header id="menu">
      <div id="menu_component">
        <nav id="menu_nav">
            <ul>
                <li className="listtitle">Menu</li>
                <span className="close" onClick={props.click}></span>
                <div className="line"></div>
                <div className="menulist">
                    <Link to="/"><li className="item">Home</li></Link>
                    <Link to="/"><li className="item" onClick={props.alert}>Blog</li></Link>
                    <Link to="/about"><li className="item">About</li></Link>
                </div>

                <div className="worklist">
                    <Link to="/subskeep"><li className="item">Subskeep</li></Link>
                    <Link to="/neulcatte"><li className="item">Neulcatte</li></Link>
                    <Link to="/tving"><li className="item">Tving</li></Link>
                </div>
            </ul>
        </nav>
      </div>
    </header>
    </>
)
  
 
  export default menu
  